
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VSelect, { VSelectOption } from "@/components/Common/VSelect.vue";
import Throttler from "@/utils/Throttler";
import { ContractDocument } from "../../models";

@Component({ components: { VSelect } })
export default class CategorySelect extends Vue {
  @Prop({ required: false })
  readonly selected!: any | null;

  @Prop()
  readonly queryKey?: string;

  @Prop()
  readonly label?: string;

  @Prop({ default: "Seleziona una categoria" })
  readonly placeholder?: string;

  @Prop({ default: false })
  readonly preselect!: boolean;

  @Prop({ default: false })
  readonly actsAsFilter!: boolean;

  @Prop()
  readonly filter!: any;

  @Prop({ default: false }) includeAll!: boolean;

  options: VSelectOption[] = [];

  private value: any | null = this.selected || null;

  private items: any[] = [];
  private term: string | null = null;
  private throttler: Throttler = new Throttler();

  mounted() {
    this.loadItems();
  }

  onSearched(term: string) {
    this.throttler.run(() => {
      this.term = term;
      this.loadItems();
    });
  }

  @Watch("selected")
  onSelectedChanged(selected: string) {
    this.value = selected;
    this.onItemsReady();
  }

  get payload() {
    let data: any = {
      page: {
        size: 100,
      },
    };

    if (this.filter) {
      data.filter = this.filter;
      if (this.term) {
        data.filter.term = this.term;
      }
    } else {
      data.filter = { term: this.term };
    }

    return data;
  }

  get filterDefault() {
    return { id: "all", text: "Tutto" };
  }

  onSelected(id: string) {
    this.value = id;
    this.$emit("input", id);
    this.$emit(
      "inputRaw",
      this.items.find((o: any) => o.id === id)
    );

    if (this.queryKey && this.$route.query[this.queryKey] !== this.value) {
      let query = this.$route.query;
      query[this.queryKey] = this.value;

      this.$router.push({ query });
    }
  }

  onItemsReady() {
    if (!this.value) {
      if (this.preselect) {
        this.value = this.options[0].id;
      }
    } else {
      this.value = this.options.find(
        (o) => o.id === this.selected.toString()
      )?.id;
    }
  }

  async loadItems() {
    if (this.actsAsFilter) {
      this.options.unshift(this.filterDefault);
    }

    this.items = ContractDocument.categories;
    this.options = this.items.map((o: any) => {
      return { id: o.id, text: o.label };
    });

    if (this.includeAll) {
      this.options.push({ id: "all", text: "Tutte le categorie" });
    }

    this.onItemsReady();
  }
}
